import React, { Fragment } from 'react'
import { shape, func, string, bool } from 'prop-types'
import BrandLoader from '../BrandLoader/BrandLoader'

import { useSelector } from 'react-redux'
import { selectLabels } from '../../redux/configuration/selectors'
import { selectLanguage } from '../../redux/session/selectors'

import CrossingSlider from '../crossings/CrossingSlider/CrossingSlider'
import PageWarningBanner from '../PageWarningBanner/PageWarningBanner'

const RouteSelection = ({
  crossings,
  departureDate,
  route,
  selectCrossing,
  currentSelection,
  continueButtonText,
  continueIsDisabled,
  continueClickHandler,
  newRoutesClickHandler,
  isLoading,
  activeVehicleResourceCode,
  activeVehicle,
  titleLabel
}) => {
  const labels = useSelector(selectLabels)
  const language = useSelector(selectLanguage)

  const departureTitle = labels[`${route?.code}Caption`] || route.description

  return (
    <div className="crossing-selections u-container u-page-view-container">
      <div className="crossings">
        <h1 className="page-title theme-font-header">
          {language === 'fr'
            ? `${titleLabel} : ${departureTitle}`
            : `${titleLabel}: ${departureTitle}`}
        </h1>
        {isLoading ? (
          <BrandLoader />
        ) : (
          <>
            {labels.selectedCrossingAvailabilityMessage && (
              <div className="padded-container" style={{ paddingBottom: 0 }}>
                <PageWarningBanner
                  message={labels.selectedCrossingAvailabilityMessage}
                >
                  <span>{labels.selectedCrossingAvailabilityMessage}</span>
                </PageWarningBanner>
              </div>
            )}
            {crossings && (
              <div className="crossings-container">
                {Object.keys(crossings).length ? (
                  <Fragment>
                    <CrossingSlider
                      crossings={crossings}
                      departureDate={departureDate}
                      selectCrossing={selectCrossing}
                      currentSelection={currentSelection}
                      activeVehicleResourceCode={activeVehicleResourceCode}
                      activeVehicle={activeVehicle}
                      labels={labels}
                    />
                  </Fragment>
                ) : (
                  <p className="crossing-selection__not-available theme-font-header">
                    {labels.noCrossingsAvailable}
                  </p>
                )}
              </div>
            )}
          </>
        )}
      </div>
      <div className="crossing-submit-container u-page-submit-container">
        {!(crossings && Object.keys(crossings).length) ? null : (
          <button
            className="btn btn-primary large-primary-btn"
            disabled={!continueIsDisabled || isLoading ? '' : 'disabled'}
            onClick={continueClickHandler}
          >
            {continueButtonText} →
          </button>
        )}
        {crossings && !Object.keys(crossings).length && (
          <button
            className="btn btn-primary large-primary-btn"
            onClick={() => {
              if (newRoutesClickHandler) newRoutesClickHandler()
            }}
          >
            Select Different Dates
          </button>
        )}
      </div>
    </div>
  )
}

RouteSelection.propTypes = {
  crossings: shape(),
  departureDate: shape(),
  route: shape(),
  selectCrossing: func,
  currentSelection: shape(),
  continueButtonText: string,
  continueIsDisabled: bool,
  continueClickHandler: func,
  newRoutesClickHandler: func,
  isLoading: bool,
  activeVehicleResourceCode: string,
  activeVehicle: shape(),
  titleLabel: string
}

export default RouteSelection
